import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HomeComponent } from './Home/Home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
// import { LoginComponent } from './Login/Login.component';
import { UrlSegment } from '@angular/router';

function caseInsensitiveMatcher(url: UrlSegment[], path: string) {
  if (url.length === 0) {
    return null;
  }
  const regex = new RegExp(`^${path}$`, 'i'); // 'i' for case-insensitive
  if (url[0].path.match(regex)) {
    return { consumed: url };
  }
  return null;
}


const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },

  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },


  { path: 'Login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: 'BookMgr', loadChildren: () => import('./book-mgr/book-mgr.module').then(m => m.BookMgrModule) },

  { path: 'Nagotiation', loadChildren: () => import('./nagotiation/nagotiation.module').then(m => m.NagotiationModule) },

  { path: 'AssignContact', loadChildren: () => import('./assign-contact/assign-contact.module').then(m => m.AssignContactModule) },

  { path: 'VivianChatTest', loadChildren: () => import('./vivian-chat-test/vivian-chat-test.module').then(m => m.VivianChatTestModule) },
  { path: 'Zalo', loadChildren: () => import('./zalo/zalo.module').then(m => m.ZaloModule) },

  { path: 'AddContact', loadChildren: () => import('./add-contact/add-contact.module').then(m => m.AddContactModule) },
  { path: 'GoiLai', loadChildren: () => import('./dashboard/goi-lai/goi-lai.module').then(m => m.GoiLaiModule) },
  { path: 'TagMgr', loadChildren: () => import('./tagmgn/tagmgn.module').then(m => m.TagmgnModule) },
  { path: 'customers', loadChildren: () => import('./customers/customers.module').then(m => m.CustomersModule) },
  { path: 'MarketingReport', loadChildren: () => import('./marketing-report/marketing-report.module').then(m => m.MarketingReportModule) },
  { path: 'DatMua', loadChildren: () => import('./dat-mua/dat-mua.module').then(m => m.DatMuaModule) },
  { path: 'EmailAnalytic', loadChildren: () => import('./email-analytic/email-analytic.module').then(m => m.EmailAnalyticModule) },
  { path: 'AIEmailFollowUp', loadChildren: () => import('./ai-email-follow-up/ai-email-follow-up.module').then(m => m.AiEmailFollowUpModule) },
  { path: 'SubizAnalytic', loadChildren: () => import('./email-analytic/subiz-analytic/subiz-analytic.module').then(m => m.SubizAnalyticModule) },
  // { path: 'SubizPhone', loadChildren: () => import('./SubizPhone/SubizPhone.module').then(m => m.SubizPhoneModule) },
  { path: 'UserReport', loadChildren: () => import('./nagotiation/user-report/user-report.module').then(m => m.UserReportModule) },
  { path: 'SaleReport', loadChildren: () => import('./nagotiation/sale-report/sale-report.module').then(m => m.SaleReportModule) },
  { path: 'CallDetail', loadChildren: () => import('./call-detail/call-detail.module').then(m => m.CallDetailModule) },
  { path: 'CallTran', loadChildren: () => import('./call-tran/call-tran.module').then(m => m.CallTranModule) },
  { path: 'SachDeThiDoc', loadChildren: () => import('./sach-de-thi-doc/sach-de-thi-doc.module').then(m => m.SachDeThiDocModule) },
  { path: 'TimKiem', loadChildren: () => import('./tim-kiem/tim-kiem.module').then(m => m.TimKiemModule) },
  { path: 'KTTD', loadChildren: () => import('./kttd/kttd.module').then(m => m.KTTDModule) },
  { path: 'KTTDXemKQ', loadChildren: () => import('./kttdxem-kq/kttdxem-kq.module').then(m => m.KTTDXemKQModule) },
  { path: 'adsmgr', loadChildren: () => import('./adsmng/adsmng.module').then(m => m.AdsmngModule) },
  { path: 'SubizPhone', loadChildren: () => import('./subiz-phone/subiz-phone.module').then(m => m.SubizPhoneModule) },
  { path: 'SaleHomePage', loadChildren: () => import('./sale-home-page/sale-home-page.module').then(m => m.SaleHomePageModule) },
  { path: 'CRMAI', loadChildren: () => import('./crmai/crmai.module').then(m => m.CrmaiModule) },
  { path: 'Sale', loadChildren: () => import('./sale/sale.module').then(m => m.SaleModule) },
  { path: 'NguoDaThanhToan', loadChildren: () => import('./nguo-da-thanh-toan/nguo-da-thanh-toan.module').then(m => m.NguoDaThanhToanModule) },
  { path: 'NguoiDatSach', loadChildren: () => import('./nguoi-dat-sach/nguoi-dat-sach.module').then(m => m.NguoiDatSachModule) },
  { path: 'AptisOnline', loadChildren: () => import('./aptis-online/aptis-online.module').then(m => m.AptisOnlineModule) },
  { path: 'AptisOnlineQuestionMng', loadChildren: () => import('./aptis-online-question-mng/aptis-online-question-mng.module').then(m => m.AptisOnlineQuestionMngModule) },
  { path: 'ContentMgr', loadChildren: () => import('./content-mgr/content-mgr.module').then(m => m.ContentMgrModule) },
  { path: 'BookMgr', loadChildren: () => import('./book-mgr/book-mgr.module').then(m => m.BookMgrModule) },
  { path: 'ExportData', loadChildren: () => import('./Component/CallLog/export-data/export-data.module').then(m => m.ExportDataModule) },
  { path: 'KeHoach', loadChildren: () => import('./ke-hoach/ke-hoach.module').then(m => m.KeHoachModule) },
  { path: 'PhanTich', loadChildren: () => import('./swot/swot.module').then(m => m.SwotModule) },
  { path: 'QLHV', loadChildren: () => import('./qlhv/qlhv.module').then(m => m.QLHVModule) },
  { path: 'NguoiSapHethan', loadChildren: () => import('./nguoi-sap-hethan/nguoi-sap-hethan.module').then(m => m.NguoiSapHethanModule) },
  { path: 'Test', loadChildren: () => import('./test/test.module').then(m => m.TestModule) },
  { path: 'vnpay', loadChildren: () => import('./vnpay/vnpay.module').then(m => m.VnpayModule) },
  { path: 'CauHoiMgr', loadChildren: () => import('./CauHoiMgr/CauHoiMgr.module').then(m => m.CauHoiMgrModule) },
  { path: 'AddWriting', loadChildren: () => import('./AddWriting/AddWriting.module').then(m => m.AddWritingModule) },
  { path: 'GoogleTrend', loadChildren: () => import('./GoogleTrend/GoogleTrend.module').then(m => m.GoogleTrendModule) },
  { path: 'SuaTuVung', loadChildren: () => import('./sua-tu-vung/sua-tu-vung.module').then(m => m.SuaTuVungModule) },
  { path: 'ExcelImport', loadChildren: () => import('./excel-import/excel-import.module').then(m => m.ExcelImportModule) },
  { path: 'RevokeContact', loadChildren: () => import('./revoke-contact/revoke-contact.module').then(m => m.RevokeContactModule) },
  { path: 'CRMNew', loadChildren: () => import('./CRMNew/CRMNew.module').then(m => m.CRMNewModule) },
  { path: 'OpenAI', loadChildren: () => import('./open-ai/open-ai.module').then(m => m.OpenAIModule) },
  { path: 'CRMThanhToan', loadChildren: () => import('./CRM-ThanhToan/CRM-ThanhToan.module').then(m => m.CRMThanhToanModule) },
  { path: 'ProjectAndTask', loadChildren: () => import('./project-and-task/project-and-task.module').then(m => m.ProjectAndTaskModule) },
  { path: 'QuanLyLopHoc', loadChildren: () => import('./quan-ly-lop-hoc/quan-ly-lop-hoc.module').then(m => m.QuanLyLopHocModule) },
  { path: 'CanvaEditor', loadChildren: () => import('./canva-editor/canva-editor.module').then(m => m.CanvaEditorModule) },
  { path: 'Hoc-Tap-Noi-Bo', loadChildren: () => import('./hoc-tap-noi-bo/hoc-tap-noi-bo.module').then(m => m.HocTapNoiBoModule) },
  { path: 'Customer360', loadChildren: () => import('./customer-360/customer-360.module').then(m => m.Customer360Module) },
  { path: 'DataMatrix', loadChildren: () => import('./customer-360/customer-360.module').then(m => m.Customer360Module) },
  { path: 'DatSach', loadChildren: () => import('./dat-sach/dat-sach.module').then(m => m.DatSachModule) },
  { path: 'QLBaiGiang', loadChildren: () => import('./qlbai-giang/qlbai-giang.module').then(m => m.QLBaiGiangModule) },
  { path: 'FaceookLeVy', loadChildren: () => import('./faceook-le-vy/faceook-le-vy.module').then(m => m.FaceookLeVyModule) },
  { path: 'AIQuestionMgr', loadChildren: () => import('./aiquestion-mgr/aiquestion-mgr.module').then(m => m.AIQuestionMgrModule) },
  { path: 'ScenarioMgr', loadChildren: () => import('./scenario-mgr/scenario-mgr.module').then(m => m.ScenarioMgrModule) },
  { path: 'NgayThiMgr', loadChildren: () => import('./ngay-thi-mgr/ngay-thi-mgr.module').then(m => m.NgayThiMgrModule) },
  { path: 'LichKhaiGiangMgr', loadChildren: () => import('./lich-khai-giang-mgr/lich-khai-giang-mgr.module').then(m => m.LichKhaiGiangMgrModule) },

  // { path: 'AdsManagement', loadChildren: () => import('./Ads-Management/Ads-Management.module').then(m => m.AdsManagementModule) },
  {
    path: '**',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: "enabled",
      anchorScrolling: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
